$("li.collection-title").on("click", function(e){
 	var url = $(this).attr('url');
ajaxLoadPage(url);
  
});


 var ajaxLoadPage = function (url) {
            $.ajax({
                type: 'GET',
                url: url,
                data: {},
                complete: function (data) {
                 
                  $('.display-ajax-collection').empty();
                  var selected_collection = $($.parseHTML(data.responseText)).find('div.collection-custom');

                  $('.display-ajax-collection').append(selected_collection);
                  var img_loop = $('.relative.product_image img');
                  
                  for (var i = 0;i < img_loop.length; i++) {
                   
                    var temp_src = $(img_loop[i]).attr('data-src');
                     $(img_loop[i]).attr('src',temp_src)
				  }
                  
               
                  
//                     $('#collection').html($("#collection", data.responseText).html());
//                     history.pushState({
//                         page: url
//                     }, url, url);
                }
            });
        }
 
 
// function to controll the parrallex it will be activated as soon you pass the picture 
 // and deactivated on the way up
 
//  $(function(){
//   $(window).scroll(function(){
//     var aTop = $('.parallax').height();
// var position = $('.parallax').position();
 
//     if($(this).scrollTop()>=position.top + 20){
       
//        $('.parallax').css("background-attachment","fixed");
//        $('.parallax').css("background-size","100% 90%");

//         // instead of alert you can use to show your ad
//         // something like $('#footAd').slideup();
//     }
//     if($(this).scrollTop()<=position.top + 20){
//        $('.parallax').css("background-attachment","initial");
//        $('.parallax').css("background-size","100% 100%");
//     }
//   });
 


// });


  // remove media for twitter
$(document).ready(function() { 
  
 
  $('#twitter-widget-0').contents().find('.timeline-Tweet-media').hide();

  var tid = setTimeout(removeImage, 50);
function removeImage() {

  var twitter = $('#twitter-widget-0').contents().find('.timeline-Tweet-media').length;
  if(twitter>0){
    $('#twitter-widget-0').contents().find("p.timeline-Tweet-text").wrap("<a href='https://twitter.com/poopsheart' target='_blank'></a>");
   
     $('#twitter-widget-0').contents().find('.timeline-Tweet-media').hide();
     abortTimer();
  }
  else
  {
  tid = setTimeout(removeImage, 1000); // repeat myself
  }
}
function abortTimer() { // to be called when you want to stop the timer
 
  window.clearTimeout(tid);
}



});



